import LocalData from "../components/ui/LocalDataWidget";
import { helpers } from "./helpers";

export const saveDraft = {
    components: { LocalData },
    data() {
        return {
            draft: null,
            endpoint: {
                method: "",
                url: "",
            },
        };
    },

    watch: {
        "endpoint.url"() {
            if (this.endpoint.method && this.endpoint.url) {
                this.getLocallySavedData(this.getStorageKey());
            }
        },
    },

    methods: {
        saveDraft(error, data, endpoint = null) {
            let key = this.getStorageKey();
            if (endpoint) {
                key = this.getStorageKey(endpoint.method, endpoint.url);
            }
            if (!error.response || error.message === "Network Error") {
                if (window.localStorage.getItem(key)) {
                    console.warn("There is previously stored data for this operation.");
                } else {
                    window.localStorage.setItem(
                        key,
                        JSON.stringify({
                            stored_at: this.moment().format("YYYY-MM-DD HH:mm"),
                            data,
                        })
                    );
                    alert(
                        "The save operation was not completed due to a network error. The data has been saved locally and you can retry saving later."
                    );
                    if (!endpoint) {
                        this.getLocallySavedData(key);
                    }
                }
            }
        },

        getStorageKey(method = this.endpoint.method, url = this.endpoint.url) {
            return `${method}@${url}`;
        },

        getLocallySavedData(key) {
            let draft = window.localStorage.getItem(key);
            if (draft) {
                try {
                    this.draft = JSON.parse(draft);
                } catch (error) {
                    console.error(error);
                }
            }
        },

        setEndpoint(method = "", url = "") {
            this.endpoint.method = method;
            this.endpoint.url = url;
        },

        eraseDraft(method = this.endpoint.method, url = this.endpoint.url) {
            window.localStorage.removeItem(this.getStorageKey(method, url));
            this.setEndpoint();
            this.draft = null;
        },

        retrySave(secondEndpoint) {
            let { method, url } = this.endpoint;
            helpers.toggleSpinner("draft-details");
            axios({
                method,
                url,
                data: this.draft.data,
            })
                .then(response => {
                    this.treatSecondaryData(secondEndpoint);
                    helpers.toggleSpinner("draft-details");
                    this.eraseDraft();
                })
                .catch(error => {
                    helpers.toggleSpinner("draft-details");
                    this.saveDraft(error, this.draft.data, this.getStorageKey(method, url));
                    console.error(error);
                });
        },

        treatSecondaryData(secondEndpoint = null) {
            if (secondEndpoint) {
                const { secondMethod, secondUrl } = secondEndpoint;
                this.getLocallySavedData(this.getStorageKey(secondMethod, secondUrl));
                axios({
                    method: secondEndpoint.method,
                    url: secondEndpoint.url,
                    data: this.draft.data,
                }).then(_ => {
                    window.localStorage.removeItem(
                        this.getStorageKey(secondEndpoint.method, secondEndpoint.url)
                    );
                });
            }
        },
    },
};
